import React, { Component } from "react";
import { Responsive } from "react-admin";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import EmailIcon from "@material-ui/icons/Email";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";

export default class EmailButton extends Component {
    state = { showSnackBar: false, error: false };

    sendMail = () => {
        const { action, resource_id } = this.props;
        const body = {
            data: {
                action,
                resource_id
            }
        };
        myRestClient("CREATE", "email", body).then(
            () => {
                this.setState({ showSnackBar: true });
            },
            () => {
                this.setState({ error: true });
                return;
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({ error: false, showSnackBar: false })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText resource_name="resources.email.actions.mailSent" />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText resource_name="resources.email.actions.errorMail" />
            </span>
        );
    }

    render() {
        return (
            <span>
                <Button color="primary" target="_blank" onClick={this.sendMail}>
                    <Responsive
                        small={
                            <Tooltip
                                title={
                                    <TranslatedText resource_name="resources.email.actions.sendMail" />
                                }
                            >
                                <EmailIcon />
                            </Tooltip>
                        }
                        medium={<EmailIcon />}
                    />
                    <Responsive
                        small={<span />}
                        medium={
                            <span style={{ paddingLeft: "0.5em" }}>
                                <TranslatedText resource_name="resources.email.actions.sendMail" />
                            </span>
                        }
                    />
                </Button>
                {this.renderSnackBar()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EmailButton.js